export default __webpack_public_path__ + "static/media/event_item_card.70ef64a9.png";